import { UserOutlined } from '@ant-design/icons';
import { Select, SelectProps } from 'antd';
import { useState } from 'react';
import { User, findUserByUsernameOrEmail } from '../../apis/mgmt/api';


export function UserSearchSelect(props: SelectProps<any> & {
  selected?: User
}) {

  const { selected } = props;

  const [data, setData] = useState<User[]>([]);  

  const handleSearch = (newValue: string) => {
    findUserByUsernameOrEmail({ search: newValue, size: 10 }).then((result) => {
      setData(result.data.content || []);
    });
  };

  return (
    <Select
      {...props}
      placeholder={props.placeholder || "Username"}
      showSearch
      defaultActiveFirstOption={false}
      suffixIcon={ <UserOutlined className="site-form-item-icon" />}
      filterOption={false}
      onSearch={handleSearch}
      notFoundContent={null}
    >

      {/* Be sure to include the selected option if search data is not loaded yet */}
      {(selected?.id && !(data && data.length)) && <Select.Option value={selected.id}>{`${selected.username} <${selected.email}>`}</Select.Option>}

      {(data).map((d) => (
        <Select.Option key={d.id} value={d.id}>{`${d.username} <${d.email}>`}</Select.Option>
      ))}

    </Select>
  );
  
};